<template>
    <section class="pb-20 md:pb-6">
        <div class=" w-1/2 m-auto text-center font-poppins mt-20 lg:w-full lg:p-2">
            <p class=" text-3xl md:text-xl">Frequently asked questions</p>
            <p class="  mt-10">
                Below you will find answers to the questions we get asked the most about our services.
            </p>
        </div>
        <div class=" w-1/2 m-auto lg:w-full lg:p-2 font-poppins">
            <div class="  mt-10">
                <div v-for="f in faqs" :key="f" class="mt-3 bg-blue-300  p-4">
                    <div class=" flex justify-between">
                        <p class=" text-blue-700 font-bold">{{f.question}}</p>
                        <button @click="f.viewContent = !f.viewContent" class=" font-bold text-2xl">
                            <i class="fa text-sm" :class="[f.viewContent ? 'fa-minus' : 'fa-plus']" aria-hidden="false" ></i>
                        </button>
                    </div>
                    <div name="content-view" v-show="f.viewContent" class=" mt-1 mr-20 lg:mr-0">
                        <p class="mb-2 text-base">{{f.answer}}</p>
                        <a class="text-blue-600 underline mt-2 text-sm" :href="f.link">{{f.link}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            content: true,
            viewContent: null,
            faqs: [
                {
                question: "Can I have a fleet of bikes as an operator and still register under CarryGo?",
                answer: `Absolutely! Moreso, you can have all  your riders onboarded and efficiently managed by the CG Super Admin. It is always easier and better with CarryGo.`,
                link: ""
                },
                {
                question: "Can I still use the app service after completing my pay on the Hired Purchase scheme?",
                answer:"You can still carry on with CarryGo after completion of the HP Programme. After completing your hired payment, you will be re-registered as an independent DSP where you will continue to enjoy the full benefits of the CarryGo App Service.",
                link: ""
                },
                {
                question: "Can I register my car for Cab Hailing under CarryGo?",
                answer: "Yes! The CarryGo App provides Cab hailing services and you can register your vehicle via this link below",
                link: "https://carrygo.me/dso-step-one-registration"
                },
                {
                question: "How can I become a haulage DSP with CarryGo?",
                answer: `Follow the link below and click on 'Apply as DSP'. On registering, select 'Haulage' Carrier Mode. Fill in the  necessary details accordingly. A CG-Agent will contact you for further  verification and then you are good to CarryGo.`,
                link: "https://carrygo.me/dso-step-one-registration"
                },
                {
                question: "Who needs to download the CarryGo Riders App?",
                answer:"Only CG-Carriers and DSP carriers are to download the riders app. This includes motorcycle and cab-hailing service providers. Haulage DSP's do not require an app as requests are rerouted to them from CarryGo via direct calls to enable flexible quotes as haulage services can be more complex and tasking. Cab hailing DSP companies or motorcycle fleet owners can register their companies online via the link below and have their drivers and riders download the CG Carrier App.",
                link: "https://carrygo.me/dso-rider-registration"
                }
            ]
        }
    },    
}
</script>